<template>
  <div>
    <PageHeader :title="update ? 'ویرایش اطلاعات شغل' : 'اضافه کردن شغل'" :items="pageHeaderItems" />

    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="card mb-3 p-3">
          <b-form-checkbox v-model="model.careerGuarantee" class="pt-2">
            <div class="mx-1">ضمانت اشتغال</div>
          </b-form-checkbox>
        </div>

        <div class="card mb-3 p-3">
          <div class="section-title">موضوع</div>
          <div class="mt-3">
            <BaseText :maxlength="2000" :value="search" @input="search = $event" placeholder="جستجو" />
          </div>

          <div :class="{ subject: filteredCategory.length > 5 }">
            <Radio :componentData="filteredCategory" :value="model.careerCategoryId" @input="model.careerCategoryId = $event" />
          </div>

          <!-- <label v-if="submit && !model.careerCategoryId" :class="{ career_type_error: submit && !model.careerCategoryId }">{{ errorText }}</label> -->
        </div>

        <div class="card mb-3 p-3">
          <BaseText :maxlength="2000" :value="model.showOrder" @input="model.showOrder = $event" title="ترتیب نمایش در خانه" placeholder="ترتیب نمایش در خانه" />
        </div>

        <div class="card p-3 mt-3 my-auto d-flex flex-column justify-content-between">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column">
              <b-form-checkbox v-model="model.doNotShowCareer" class="pt-2">
                <div class="mx-1">عدم نمایش شغل</div>
              </b-form-checkbox>
            </div>
            <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary">
              <i class="far fa-times-circle"></i>
              <span class="ms-2">حذف شغل</span>
            </b-button>
          </div>
        </div>

        <div class="inner__style mt-3">
          <ImageUploader
            :img="model.careerIntroduceImage"
            :uploadLoading="careerIntroduceImageLoading"
            title="عکس مورد نظر خود را انتخاب نمایید"
            secondTitle="سایز پیشنهادی : 600 * 990 "
            @uploadImage="uploadImage"
            @deleteImage="model.careerIntroduceImage = ''"
          />

          <div class="my-3">
            <TextAreaInput
              :maxlength="100"
              :value="model.careerIntroduceImageAlternateText"
              @input="model.careerIntroduceImageAlternateText = $event"
              title="متن جایگزین "
              placeholder="متن جایگزین عکس"
              rows="2"
            />
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card">
          <Section title="اطلاعات شغل">
            <div class="my-3">
              <BaseText
                required
                :showError="submit && !model.title"
                errortext="عنوان شغل را وارد کنید."
                :maxlength="2000"
                :value="model.title"
                @input="model.title = $event"
                title="عنوان شغل"
                placeholder="عنوان شغل"
              />
            </div>

            <div class="my-3">
              <BaseText
                required
                :showError="submit && !model.description"
                errortext="توضیحات کوتاه را وارد کنید."
                :maxlength="2000"
                :value="model.description"
                @input="model.description = $event"
                title="توضیحات کوتاه"
                placeholder="توضیحات کوتاه"
              />
            </div>
          </Section>
        </div>

        <div class="card">
          <Section title="حقوق متوسط">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.salary" @input="model.salary = $event" title="حقوق شغل" placeholder="حقوق شغل" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.otherSalary" @input="model.otherSalary = $event" title="سایر حقوق ها" placeholder="سایر حقوق ها" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.careerCount" @input="model.careerCount = $event" title="تعداد شغل موجود" placeholder="تعداد شغل موجود" />
            </div>
          </Section>
        </div>
        <div class="card">
          <h5 class="px-3 pt-3">اطلاعات دوره های جاری</h5>
          <Section title="دوره یک">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.courseTitle1" @input="model.courseTitle1 = $event" title="عنوان دوره" placeholder="عنوان دوره" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.courseLinqTo1" @input="model.courseLinqTo1 = $event" title="لینک شود به" placeholder="لینک شود به" />
            </div>
            <div class="d-flex">
              <div class="labelStyle">لوگو برگزار کننده</div>
              <div class="w-100">
                <ImageUploader
                  :img="model.organizerLogo1"
                  :uploadLoading="logoLoading1"
                  title="عکس مورد نظر خود را انتخاب نمایید"
                  @uploadImage="uploadLogoImage($event, 1)"
                  @deleteImage="model.organizerLogo1 = ''"
                />
              </div>
            </div>
          </Section>

          <Section title="دوره دو">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.courseTitle2" @input="model.courseTitle2 = $event" title="عنوان دوره" placeholder="عنوان دوره" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.courseLinqTo2" @input="model.courseLinqTo2 = $event" title="لینک شود به" placeholder="لینک شود به" />
            </div>
            <div class="d-flex">
              <div class="labelStyle">لوگو برگزار کننده</div>
              <div class="w-100">
                <ImageUploader
                  :img="model.organizerLogo2"
                  :uploadLoading="logoLoading2"
                  title="عکس مورد نظر خود را انتخاب نمایید"
                  @uploadImage="uploadLogoImage($event, 2)"
                  @deleteImage="model.organizerLogo2 = ''"
                />
              </div>
            </div>
          </Section>

          <Section title="دوره سه">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.courseTitle3" @input="model.courseTitle3 = $event" title="عنوان دوره" placeholder="عنوان دوره" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.courseLinqTo3" @input="model.courseLinqTo3 = $event" title="لینک شود به" placeholder="لینک شود به" />
            </div>
            <div class="d-flex">
              <div class="labelStyle">لوگو برگزار کننده</div>
              <div class="w-100">
                <ImageUploader
                  :img="model.organizerLogo3"
                  :uploadLoading="logoLoading3"
                  title="عکس مورد نظر خود را انتخاب نمایید"
                  @uploadImage="uploadLogoImage($event, 3)"
                  @deleteImage="model.organizerLogo3 = ''"
                />
              </div>
            </div>
          </Section>
        </div>

        <div class="card">
          <Section title="محتوای بیشتر">
            <div>
              <EditorInput :value="model.moreContent" @input="model.moreContent = $event" title="محتوای صفحه" :hasImage="false" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>

        <div class="card">
          <Section title="تنظیمات سئو">
            <div class="my-3">
              <Tags title="کلیدواژه" :value="model.seoKeyword" classes="tags" @input="model.seoKeyword = $event" placeholder="کلیدواژه" />
            </div>
            <div class="my-3">
              <TextAreaInput :value="model.seoDescription" @input="model.seoDescription = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.seoUrlDescription" @input="model.seoUrlDescription = $event" title="متن URL" placeholder="متن URL" />
            </div>
          </Section>
        </div>
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button variant="outline-secondary" @click="$router.push('/list/skillupcourses')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addCareer">ثبت </b-button>
    </div>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف شغل اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deleteCareer">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <Toast :title="message" :error="error" :showToast="message !== ''" />
  </div>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import fileMannager from '../../../services/file'
import skillUpCareerProvider from '../../../services/skillUp/career'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import Section from '../../common/form/Section.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import Tags from '../../common/form/formModules/Tags.vue'
import ImageUploader from '../../user/ImageUploader.vue'
import PageHeader from '../../layoutComponents/page-header.vue'
import Radio from '../../common/form/formModules/Radio.vue'

export default {
  name: 'AddCareer',
  components: {
    Toast,
    Loader,
    Section,
    BaseText,
    EditorInput,
    TextAreaInput,
    Tags,
    ImageUploader,
    PageHeader,
    Radio,
  },
  props: {
    update: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        title: '',
        description: '',
        salary: '',
        otherSalary: '',
        careerCount: '',
        courseTitle1: '',
        courseLinqTo1: '',
        organizerLogo1: '',
        courseTitle2: '',
        courseLinqTo2: '',
        organizerLogo2: '',
        courseTitle3: '',
        courseLinqTo3: '',
        organizerLogo3: '',
        moreContent: '',
        seoKeyword: '',
        seoDescription: '',
        seoUrlDescription: '',
        careerGuarantee: false,
        careerCategoryId: '',
        showOrder: '',
        doNotShowCareer: false,
        careerIntroduceImage: '',
        careerIntroduceImageAlternateText: '',
      },
      imageCrop: { width: 1102, height: 670 },
      loading: false,
      error: false,
      message: '',
      cropperLoading: false,
      search: '',
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت شغل ها', active: true },
      ],
      careerCategories: [],
      logoLoading1: false,
      logoLoading2: false,
      logoLoading3: false,
      careerIntroduceImageLoading: false,
      submit: false,
    }
  },
  computed: {
    filteredCategory() {
      return this.careerCategories.filter((item) => {
        return item.value.includes(this.search)
      })
    },
  },
  watch: {
    'model.salary'(c) {
      if (c && !this.submit) {
        this.model.salary = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.otherSalary'(c) {
      if (c && !this.submit) {
        this.model.otherSalary = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.careerCount'(c) {
      if (c && !this.submit) {
        this.model.careerCount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
  },
  mounted() {
    if (this.update) {
      this.fetchCareer()
    }
    this.fetchCareerInputs()
  },
  methods: {
    async uploadLogoImage(e, index) {
      this[`logoLoading${index}`] = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this[`logoLoading${index}`] = false
      this.model[`organizerLogo${index}`] = req.data.data.downloadUrl
    },
    async uploadImage(e) {
      this.careerIntroduceImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.model.careerIntroduceImage = req.data.data.downloadUrl
      this.careerIntroduceImageLoading = false
    },
    async addCareer() {
      this.submit = true
      if (!this.model.title || !this.model.description) {
        window.scrollTo(0, 0)
        return
      }
      if (!this.update) {
        for (const key in this.model) {
          if (this.model[key] === '' || this.model[key] === undefined || this.model[key] === null) {
            delete this.model[key]
          }
        }
      }
      if (this.model.salary && typeof this.model.salary === 'string') {
        this.model.salary = this.model.salary.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.salary = +this.model.salary
      }
      if (this.model.otherSalary && typeof this.model.otherSalary === 'string') {
        this.model.otherSalary = this.model.otherSalary.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.otherSalary = +this.model.otherSalary
      }
      if (this.model.careerCount && typeof this.model.careerCount === 'string') {
        this.model.careerCount = this.model.careerCount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.careerCount = +this.model.careerCount
      }
      if (this.model.showOrder) this.model.showOrder = +this.model.showOrder

      try {
        this.loading = true
        if (this.update) {
          const req = await skillUpCareerProvider.updateCareer(this.model)
          if (req.status === 200) {
            this.submit = false
            this.model.salary = this.model.salary.toString()
            this.model.otherSalary = this.model.otherSalary.toString()
            this.model.careerCount = this.model.careerCount.toString()
            this.loading = false
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          return false
        }

        const req = await skillUpCareerProvider.addCareer(this.model)
        if (req.status === 200) {
          this.submit = false
          this.message = 'شغل با موفقیت ثبت شد.'
          setTimeout(() => {
            this.$router.push('/list/skillupallcareers/detail/' + req.data.data.id)
          }, 2000)
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    async fetchCareer() {
      this.loading = true
      try {
        if (this.update) {
          const req2 = await skillUpCareerProvider.getCareer(+this.$route.params.careerId)
          this.model = req2.data.data.careerDetails
          this.model.salary = this.model.salary.toString()
          this.model.otherSalary = this.model.otherSalary.toString()
          this.model.careerCount = this.model.careerCount.toString()
        }

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchCareerInputs() {
      this.loading = true
      const req = await skillUpCareerProvider.getInputs()
      req.data.data.output.courseCategories.forEach((item) => {
        this.careerCategories.push({ value: item.title, key: item.id })
      })
      this.loading = false
    },

    async deleteCareer() {
      this.loading = true
      try {
        await skillUpCareerProvider.deleteCareer(+this.$route.params.careerId)
        this.$bvModal.hide('deleteModal')
        this.$router.push('/list/skillupallcareers')
      } catch (error) {
        this.error = true
        this.loading = false
        this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.accept-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #34c38f;
  text-align: center;
  background: rgba(52, 195, 143, 0.1);
  // border: 1px solid rgba(52, 195, 143, 0.3);
  border-radius: 100px;
}

.upload_video {
  height: 281px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 25px;
  background-color: white;
}

.video {
  width: 100%;
  height: 122px;
  border-radius: 8px;
  // margin: 20px 20px 0 20px;
}

.pro {
  width: 210px;
}

.progress-b {
  margin: 15px auto;
  direction: ltr;
  width: 85%;
  position: relative;
  left: -10px;
}

.percent {
  width: 100%;
  font-size: 12px;
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  top: -28px;
  right: -10px;
}

.upload_text {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}

.second_upload_text {
  font-size: 15px;
  text-align: center;
  margin-top: 10px;
  color: rgba(153, 150, 150, 1);
}

.close_icon {
  position: absolute;
  top: 2px;
  left: 15px;
  font-size: 20px;
  color: grey;
  cursor: pointer;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo-main {
  display: flex;
  flex-wrap: wrap;
}
.uploaded-photo {
  height: 120px;
  width: 160px;
  position: relative;
  margin-left: 10px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.uploaded-video {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  z-index: 1;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    color: #ff4861;
  }
}
.previewImage {
  border-radius: 4px;
}
.previewVideo {
  border-radius: 4px;
  width: 100%;
}

.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
}
::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .text-muted {
  display: none;
}

.date-header {
  font-size: 17px;
  margin: 16px;
}

.selected {
  border: 3px solid #556be6;
}

.upload-video-parent {
  width: 100%;
}

::v-deep .mainInput {
  margin-right: 0;
}

::v-deep .main_box {
  width: 100%;
}

::v-deep .b-form-tags-button {
  display: none;
}

.accept-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #34c38f;
  text-align: center;
  background: rgba(52, 195, 143, 0.1);
  // border: 1px solid rgba(52, 195, 143, 0.3);
  border-radius: 100px;
}

.reject-badge {
  width: 95px;
  height: 22px;
  color: #f46a6a;
  font-size: 13px;
  text-align: center;
  background: rgba(244, 106, 106, 0.180392);
  // border: 1px solid rgba(255, 35, 87, 0.3);
  border-radius: 100px;
}

.need-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #556ee6;
  text-align: center;
  background: rgba(85, 110, 230, 0.1);
  // border: 1px solid rgba(85, 110, 230, 0.3);
  border-radius: 100px;
}

.waiting-badge {
  width: 95px;
  height: 22px;
  color: #fcbd35;
  font-size: 13px;
  text-align: center;
  background: rgba(240, 209, 34, 0.18);
  // border: 1px solid rgba(255, 35, 87, 0.3);
  border-radius: 100px;
}

::v-deep .card {
  overflow: visible;
}

.subject {
  max-height: 150px;
  min-height: 150px;
  overflow-y: auto;
}

::v-deep .membersEnable .custom-control-label {
  margin: 0;
}

::v-deep .labelStyle {
  min-width: 80px !important;
}

.disable {
  opacity: 0.5;
  pointer-events: none;
}

.career_type_error {
  color: rgb(254, 94, 97);
}

::v-deep .input__style {
  font-weight: 600;
}

::v-deep .disableInput {
  color: black !important;
  font-weight: 600;
}

.labelStyle {
  min-width: 90px;
  max-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
  padding-top: 10px;
}
</style>
